export enum AppCustomEvent {
  APP_RENDERED = 'APP_RENDERED',
  CLEAR_ALL_SERVICE_CACHE = 'CLEAR_ALL_SERVICE_CACHE',
  CLEAR_SERVICE_CACHE = 'CLEAR_SERVICE_CACHE',
  REGISTER_TOAST = 'REGISTER_TOAST',
  REGISTER_CUSTOM_TOAST = 'REGISTER_CUSTOM_TOAST',
  DISMISS_CURRENT_TOAST = 'DISMISS_CURRENT_TOAST',
  DISMISS_ALL_TOASTS = 'DISMISS_ALL_TOASTS',
  USER_LOGGED_IN = 'USER_LOGGED_IN',
  USER_LOGGED_OUT = 'USER_LOGGED_OUT',
}
